let onExit = ''
function enable (element, callback) {
  // 判断各种浏览器，找到正确的方法
  var requestMethod = element.requestFullScreen || // W3C
    element.webkitRequestFullScreen || // FireFox
    element.mozRequestFullScreen || // Chrome等
    element.msRequestFullScreen // IE11
  if (requestMethod) {
    requestMethod.call(element)
  } else if (typeof window.ActiveXObject !== 'undefined') { // for Internet Explorer
    var wscript = new window.ActiveXObject('WScript.Shell')
    if (wscript !== null) {
      wscript.SendKeys('{F11}')
    }
  }
  // 给exit方法重新赋值
  if (!onExit) {
    onExit = callback || function () {}
  }
}
// 退出全屏 判断浏览器种类
function exit (e) {
  if (!isFull()) {
    onExit()
    onExit = ''
  }
}
// 判断当前是否全屏
function isFull () {
  var isFull = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
  // to fix : false || undefined == undefined
  return !!isFull
}
document.addEventListener('fullscreenchange', exit)
document.addEventListener('mozfullscreenchange', exit)
document.addEventListener('webkitfullscreenchange', exit)
document.addEventListener('msfullscreenchange', exit)

export default {
  enable,
  exit
}



// WEBPACK FOOTER //
// ./src/util/fullscreen.js